<template>
	<div class="subscribe-detail">
		<nav-bar :navBarTitle="keyWord"></nav-bar>
		<div class="subscribe-detail-wrap">
			<van-list
				v-model="loading"
				:finished="finished"
				@load="onLoad"
				:finished-text="finishedText"
			>
				<ul  v-if="dataList.length">
					<li v-for="(obj,index) in dataList" :key="index" class="policylist" @click="goDetailPage(obj)">
						<list-item :item-data="obj"></list-item>
					</li>
				</ul>
			</van-list>
			<!--没有数据-->
			<no-data v-if="!dataList.length" :type="1"></no-data>
		</div>
	</div>
</template>

<script>
	import ListItem from '../../components/ListItem'
	import { cardShareInfo, reqSubscribeList } from '../../api';
	import { getUrlParams } from '../../utils';
	import NoData from '../../components/NoData'


	export default {
		name: 'subscribedetail',
		components:{
			ListItem,
			NoData
		},
		data(){
			return {
				loading: false,
				finished: false,
				size: 10, // 分页大小 d
				page: 1, // 当前页
				total:0,
				city:'',
				id:null,
				keyWord: '',
				dataList:[],
			}
		},
		computed: {
			finishedText: {
				get(){
					return this.total>0 && this.finished === true ? '没有更多了' : ''
				},
				set(){
				}
			},
		},
		created(){
			this.id = Number(getUrlParams('id')) || 0
			this.keyWord = getUrlParams('keyWord') || ''
			document.title = this.keyWord
			this.getDataList()
		},
		mounted(){
			this.defaultShare()
		},
		methods:{
			// 列表加载
			onLoad() {
				this.page++
				this.getDataList()
			},
			// 默认分享
			async defaultShare(){
				let params = {
					type: 9, // 普通分享到产品首页
					title: '政策补贴宝',
					desc: '每个企业都有获得补贴的机会，我们让可能变为现实',
				}
				let res = await cardShareInfo(params)
				if(res && res.ok){
					let data = res.data
					this.WechatShare({
						title: data.title,
						desc: data.desc,
						imgUrl: data.imgUrl,
						link: data.linkUrl
					},window.initUrl ? window.initUrl: '')
				}
			},
			async getDataList(){
				this.loading = true
				let params = {
					page: this.page,
					size: this.size,
					id: this.id,
					keyWord: this.keyWord
				}
				let res = await reqSubscribeList(params)
				console.log('获取列表', res)
				if(res.ok){
					// 加载状态结束
					this.loading = false;
					this.total = res.total
					let list  = res.data || []
					console.log('获取返回数据',list)
					this.dataList = this.dataList.concat(list)
					if (this.dataList.length >= this.total) {
						this.finished = true;
					}
				}
			},
			goDetailPage(item) {
				console.log('详情',item)
				// eslint-disable-next-line
				sensors.track('policyClick', {
					policy_id: item.policyId,
					policy_name: item.policyName,
					policy_show_type: "非模糊",
					match_level: item.matchScore,
					policy_department: item.department,
					max_declare: item.maxSubsidy
				})
				this.$router.push({
					path: '/detail',
					query: {
						policyId: item.policyId,
						isRead: item.isRead,
					}
				})
			},
		}
	};
</script>

<style scoped lang="less">
	.subscribe-detail{
		.subscribe-detail-wrap{
			padding: 12px 13px 20px 15px;
		}
	}

</style>
